import { Link, useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { useEffect,useState } from 'react';
import axios from 'axios';

import Breadcrumb from "../Pages/Breadcrumb";
import imgicon from "../../assets/icons/new-icon.png";
import Image from '../ui/Image';

import { ChevronLeft, ChevronRight, ArrowLeft } from 'lucide-react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { useLanguage } from '../../store/language-context';
import { useTranslation } from 'react-i18next';

const NewsDetails = () => {
  const { t } = useTranslation();
  const { URL } = useLanguage();
  const { id } = useParams();

  const { data: newsDetails, isLoading, error } = useQuery({
    queryKey: ['newsDetails', id, URL],
    queryFn: async () => {
      const response = await axios.get(`${URL}/latestNews/${id}`);
      if (response.status === 200) {
        return response?.data?.data || {};
      } else {
        throw new Error("Failed to fetch news details.");
      }
    },
    retry: 1,
    refetchOnWindowFocus: false,
  });
   // Track the number of characters shown
   const [expanded, setExpanded] = useState(false);

   // Function to show the description in chunks of 300 characters
   const descriptionChunk = (description, chunkSize = 300) => {
     if (description.length <= chunkSize) return description; // If description is less than or equal to 300, return it fully
 
     return expanded
       ? description // If expanded, show the full description
       : description.substring(0, chunkSize); // Otherwise, show the first 300 characters
   };
 
   // Function to remove HTML tags and inline styles from the description
   const removeHtmlAndStyles = (text) => {
     const doc = new DOMParser().parseFromString(text, "text/html");
     const cleanedText = doc.body.textContent || ""; // Remove all HTML tags
     return cleanedText;
   };
 
   const cleanedDescription = removeHtmlAndStyles(newsDetails?.description);
 
  const { data: news = [], isLoading: nsLoading, error: nsErr, refetch } = useQuery({
    queryKey: ['latestNews', URL],
    queryFn: async () => {

      const response = await axios.get(`${URL}/latestNews?page=1`);
      if (response.data.status === 200) {
        return Array.isArray(response.data.data.data)
          ? response.data.data.data
          : [response.data.data.data];
      } else {
        throw new Error("Failed to fetch latest news.");
      }
    },
    retry: 1,
    refetchOnWindowFocus: false,
  });

  useEffect(() => {
    document.title = `${newsDetails?.title} |  الأخبار` || "تفاصيل الخبر";
  }, [newsDetails]);

  if (isLoading) {
    return (
      <main className="container">
        <section className=''>
          <div className='relative'>
            <div className='l-load-dt w-full h-[33rem] aspect-video rounded-md max-lg:h-96'></div>
          </div>
          <div className='!text-start space-y-2 p-1'>
            <div className="flex items-center gap-2">
              <span>
                <div className='l-load-dt w-8 h-8 rounded-full'></div>
              </span>
              <div className='l-load-dt w-24 h-4 rounded'></div>
            </div>
            <div className='l-load-dt w-3/4 h-6 rounded'></div>
            <div className='space-y-3'>
              <div className='l-load-dt w-full h-4 rounded'></div>
              <div className='l-load-dt w-full h-4 rounded'></div>
              <div className='l-load-dt w-5/6 h-4 rounded'></div>
              <div className='l-load-dt w-full h-4 rounded'></div>
              <div className='l-load-dt w-4/5 h-4 rounded'></div>
            </div>
          </div>
        </section>
      </main>
    )
  }

  if (!newsDetails || Object.keys(newsDetails).length === 0 || error) {
    return <div>لا يوجد تفاصيل لهذا الخبر حتى الان</div>;
  }
  
  return (
    <>
      <Breadcrumb pages={[t('routes.news'), `${newsDetails?.title || t('routes.news-details')}`]} />

      <main className="container">
        <section className='grid grid-cols-[35%_60%] gap-8 max-lg:grid-cols-1 max-lg:px-2 mb-4'>
          <div className='relative'>
            <Image
              src={newsDetails?.image}
              alt={newsDetails?.title}
              className={'object-cover w-full aspect-video mb-2 rounded-md max-lg:h-full'}
              style={{ height: '20rem', maxHeight: '100%' }}
            />
          </div>
          <div className='!text-start space-y-2 p-1' style={{ border: '1px solid #C7C7C7', borderRadius: '10px', padding: '20px', direction: 'rtl' }}>
            <div className="flex items-center gap-2">
              <span>
                <img src={imgicon} alt="icon" />
              </span>
              <p style={{ margin: '0' }}>
                {newsDetails.date}
              </p>
            </div>
            <h1 className='text-xl font-semibold text-end'>
              {newsDetails.title}
            </h1>
            <article className='p-2 text-end' style={{ lineHeight: '1.6', fontSize: '16px', color: '#333' }}>
        {/* Render description with chunking and cleaned content */}
        <p>{descriptionChunk(cleanedDescription)}</p>

        {/* Show "Read More" if description is longer than 300 characters */}
        {cleanedDescription.length > 300 && (
          <button
            onClick={() => setExpanded(!expanded)}
            className="text-gray-500 mt-2 text-decoration-underline"
          >
            {expanded ? 'عرض اقل' : 'عرض المزيد'}
          </button>
        )}
      </article>
          </div>
        </section>

        <main className=''style={{marginTop: '2rem'}}>
          <div className='flex justify-start mt-4 mb-4'>
            <p className='services-header text-xl flex justify-center '>
              أخبار اخرى :
            </p>
          </div>
          <section className="flex items-center justify-between gap-2">

            <button className='flex justify-center items-center size-8 border-2 border-secondary-tw rounded-md text-secondary-tw prev-new'>
              <ChevronRight size={22} />
            </button>

            <Swiper
              modules={[Navigation, Pagination, Autoplay]}
              loop={true}
              navigation={{
                nextEl: '.next-new',
                prevEl: '.prev-new'
              }}
              spaceBetween={30}
              slidesPerView={3}
              breakpoints={{
                0: { slidesPerView: 1 },
                680: { slidesPerView: 2 },
                992: { slidesPerView: 3 },
                1200: { slidesPerView: 3 }
              }}
              autoplay={{ delay: 3000, disableOnInteraction: true }}
              draggable={true}
            >
              {nsLoading ? (
                <div>
                  <div className="grid grid-cols-3 gap-4 max-2xl:grid-cols-2 max-lg:grid-cols-1">
                    {[1, 2, 3].map((i) => (
                      <div key={i} className={`relative flex items-center justify-center flex-col ${i === 2 || i === 1 ? 'lg:flex max-lg:hidden' : ''}`}>
                        <div className="l-load w-96 h-60 rounded-md max-lg:w-full"></div>
                        <div className="absolute z-20 bottom-3 flex flex-col items-center w-full px-2 space-y-1">
                          <div className="l-load-dt w-3/4 h-5 rounded"></div>
                          <div className="l-load-dt w-40 h-8 rounded-md"></div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ) : nsErr ? (
                <div className="text-center py-8">
                  <p className="text-red-500">عذراً، حدث خطأ أثناء تحميل الأخبار</p>
                  <button
                    className="mt-2 bg-secondary-tw text-white px-4 py-2 rounded-md"
                    onClick={() => refetch && refetch()}
                  >
                    إعادة المحاولة
                  </button>
                </div>
              ) : news.length === 0 ? (
                // Empty State
                <p className="text-center py-8">لا يوجد أخبار اخرى حاليا</p>
              ) : (
                // Content
                news.map((item) => (
                  <SwiperSlide key={item.id}>
                    <div className='bg-white flex justify-center flex-col border border-gray-300 rounded-md relative overflow-hidden hover:shadow-lg transition-shadow duration-300 '>
                      <div className="relative z-0">
                        <Image
                          src={item.image}
                          alt={item.title}
                          className="w-96 h-60 rounded-md z-0"
                        />
                      </div>
                      <div className="flex items-center gap-2 mt-3 mb-3">
              <span>
                <img src={imgicon} alt="icon" />
              </span>
                      <div className='text-[#D4AD89]'>{item.date}</div>
                      </div>
                    
                      <div className="w-full z-10 absolute inset-0 bg-[#6A2F38] bg-opacity-40 h-60 rounded-md top-0"></div>
                      <div className=" z-20 bottom-3 flex flex-col items-center w-full !px-2 space-y-1 p-2" style={{minHeight: '140px'}}>
                        <p className='text-black text-right ' style={{fontSize: '16px'}}>{item.title}</p>
                        <span className='flex items-center justify-content-start gap-2 text-[#D4AD89] px-2 py-1  w-fit rounded-md'>
                          <Link to={`/news/${item?.id}`} className='text-[#D4AD89]'>
                            المزيد من التفاصيل
                          </Link>
                          <span>
                            <ArrowLeft size={18} />
                          </span>
                        </span>
                      </div>
                    </div>
                  </SwiperSlide>
                ))
              )}
            </Swiper>

            <button className='flex justify-center items-center size-8 border-2 border-secondary-tw rounded-md text-secondary-tw next-new'>
              <ChevronLeft size={22} />
            </button>

          </section>
        </main>
      </main>
    </>
  );
};

export default NewsDetails;
